<template>
	<div :class="{'button': (custom.render(scope) && custom.render(scope)!='--')}" :style="custom.getStyle && custom.getStyle(scope)" @click="click">{{custom.render(scope)}}</div>
</template>
<script>
	export default {
		props: {
			custom: {
				type: Object,
				default: ()=>{
          return {}
        }
			},
			scope: {
				type: Object,
				default: ()=>{
					return {}
				}
			},
		},
		methods: {
			click() {
        this.custom.customBindClick && this.custom.customBindClick(this.scope)
			}
		}
	}
</script>
<style lang="scss" scoped>
	.button {
    font-size: 14px;
		color: #08f;
    text-decoration: underline;
    cursor: pointer;
    margin-right: 10px;
	}
</style>